//
//
//
//
//
export default {
  name: 'Fashion',
  data: function data() {
    return {};
  }
};